// redux-persist migration for `uiReducer` version 16.
//
// `params` and `activeRouteId` mirror the current URL and were persisted until
// 2026-09. A new page then rehydrated the previous page's route state into its
// first render: a fresh OAuth popup saw the last popup's `response: 'success'`,
// mounted the response handler and closed itself before reaching the provider.
// The keys are no longer whitelisted; this strips what browsers already stored.
const dropPersistedRouteState = (state) => {
  const rest = { ...state };
  delete rest.params;
  delete rest.activeRouteId;
  return rest;
};

export default dropPersistedRouteState;
